<template>
	<div class="default">
		<ShHeader />

		<div class="layout-wrapper">
			<section>
				<NuxtImg
					alt="404"
					src="/images/404.png"
					decoding="async"
					class="image"
					width="1065"
					height="816"
					format="webp"
					sizes="sm:80vw xl:100vw"
				/>

				<div class="info">
					<h3 class="h-text">
						<span>{{ 'Страница\n' }}</span>
						<span class="h-text2">не найдена</span>
					</h3>

					<p>
						{{
							'Возможно, вы перешли по неверной \nссылке. Попробуйте начать с главной'
						}}
					</p>

					<UIShLink to="/" class="link" unstyled>
						<UIShButton
							label="Вернуться на главную"
							md
							:xl="1920"
						/>
					</UIShLink>
				</div>
			</section>
		</div>

		<FooterSection />
	</div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.default {
	width: 100%;
	height: 100%;
}

section {
	display: block;
	background-color: var(--color-gray900);
	border-radius: 1.333rem;
	position: relative;
	overflow: hidden;

	&::after {
		content: '';
		position: absolute;
		top: -21.56%;
		left: -6.73%;
		width: 91.31%;
		height: 70.24%;
		transform: rotate(-30.58deg);
		background-color: var(--color-gray800);
	}
}

.image {
	position: relative;
	width: 100%;
	height: 100%;
	z-index: var(--z-index);
	margin-inline: auto;
	object-fit: contain;
}

.info {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0.889rem;
	z-index: var(--z-index);
	position: relative;

	.h-text {
		@include useFont(dxsb);
		text-transform: uppercase;
		color: var(--color-white);

		&2 {
			color: var(--color-gray300);
		}
	}

	p {
		white-space: pre-line;
		@include useFont(tmdm);
		color: var(--color-white);
		margin-top: 0.444rem;
	}

	.link {
		margin-top: 1.778rem;
	}
}

@include screen768 {
	section {
		&::after {
			width: 56.31%;
			height: 88.31%;
		}
	}
}

@include screen1024 {
	section {
		display: grid;
		grid-template-columns: 56.31% 1fr;
		grid-template-rows: 24rem;
		align-items: center;

		&::after {
			width: 39.31%;
		}
	}
}

@include screen1440 {
	section {
		grid-template-rows: 34rem;
	}
}

@include screen1920 {
	section {
		grid-template-columns: 1fr 43.056rem;
		grid-template-rows: 45.333rem;

		&::after {
			width: 52.6%;
			height: 124.7%;
		}
	}

	.info {
		align-items: flex-start;
		padding: 2.667rem;

		.h-text {
			white-space: pre-line;
			@include useFont(d2xlb);
		}

		p {
			@include useFont(dxsm);
			margin-top: 1.111rem;
		}

		.link {
			margin-top: 2.667rem;
		}
	}
}
</style>
